(() => {
  if (window.DentalCanvasCartUpsellLoaded) return;
  window.DentalCanvasCartUpsellLoaded = true;

  const analyticsAllowed = () => {
    try {
      const privacy = window.Shopify?.customerPrivacy;
      return typeof privacy?.analyticsProcessingAllowed !== 'function' || privacy.analyticsProcessingAllowed();
    } catch (_) {
      return true;
    }
  };

  const publish = (name, payload) => {
    if (!analyticsAllowed() || !window.Shopify?.analytics?.publish) return;
    Promise.resolve(window.Shopify.analytics.publish(name, payload)).catch(() => {});
  };

  // Mirrors CartDrawerItems.getSectionsToRender so refreshed markup lands in
  // the same places Dawn's own cart updates do.
  const SECTIONS = [
    { section: 'cart-drawer', id: 'CartDrawer', selector: '.drawer__inner' },
    { section: 'cart-icon-bubble', id: 'cart-icon-bubble', selector: '.shopify-section' },
  ];

  const applySections = (sections) => {
    if (!sections) return;
    SECTIONS.forEach(({ section, id, selector }) => {
      const html = sections[section];
      const root = document.getElementById(id);
      if (!html || !root) return;
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const source = parsed.querySelector(selector) || parsed.body;
      const target = root.querySelector(selector) || root;
      target.innerHTML = source.innerHTML;
    });
    document.querySelector('cart-drawer.active .drawer__inner')?.focus();
  };

  const shownOffers = new Set();

  const publishShown = () => {
    document.querySelectorAll('[data-dc-offer]').forEach((offer) => {
      const key = offer.dataset.dcOffer;
      if (!key || shownOffers.has(key)) return;
      const drawer = offer.closest('cart-drawer');
      if (drawer && !drawer.classList.contains('active')) return;
      shownOffers.add(key);
      publish('dental_canvas:upsell_shown', {
        offer_type: offer.dataset.offerType || '',
        offer_name: offer.dataset.offerName || '',
        offer_price: offer.dataset.offerPrice || '',
        page_path: window.location.pathname,
        placement: 'cart_drawer',
      });
    });
  };

  const busy = (button, isBusy) => {
    button.toggleAttribute('disabled', isBusy);
    button.setAttribute('aria-busy', isBusy ? 'true' : 'false');
  };

  const showError = (button) => {
    const error = button.closest('[data-dc-offer]')?.querySelector('[data-dc-offer-error]');
    if (error) error.hidden = false;
  };

  const postCart = async (url, body) => {
    const response = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ ...body, sections: 'cart-drawer,cart-icon-bubble' }),
    });
    const state = await response.json();
    if (!response.ok || state.status) throw new Error(state.message || 'Cart request failed');
    return state;
  };

  const handleUpgrade = async (button) => {
    busy(button, true);
    try {
      const state = await postCart(`${window.routes?.cart_change_url || '/cart/change'}`, {
        id: button.dataset.lineKey,
        quantity: Number(button.dataset.quantity) || 1,
        selling_plan: Number(button.dataset.sellingPlanId),
      });
      publish('dental_canvas:upsell_accepted', {
        offer_type: 'plan_upgrade',
        plan_name: button.dataset.planName || '',
        price: button.dataset.planPrice || '',
        page_path: window.location.pathname,
        placement: 'cart_drawer',
      });
      applySections(state.sections);
      publishShown();
    } catch (_) {
      showError(button);
      busy(button, false);
    }
  };

  const handleBump = async (button) => {
    busy(button, true);
    try {
      const state = await postCart(`${window.routes?.cart_add_url || '/cart/add'}`, {
        items: [{ id: Number(button.dataset.variantId), quantity: 1 }],
      });
      publish('dental_canvas:bump_added', {
        offer_type: 'order_bump',
        product_name: button.dataset.productName || '',
        price: button.dataset.productPrice || '',
        page_path: window.location.pathname,
        placement: 'cart_drawer',
      });
      applySections(state.sections);
      publishShown();
    } catch (_) {
      showError(button);
      busy(button, false);
    }
  };

  document.addEventListener('click', (event) => {
    const upgrade = event.target.closest('[data-dc-upsell-accept]');
    if (upgrade && !upgrade.hasAttribute('disabled')) {
      handleUpgrade(upgrade);
      return;
    }
    const bump = event.target.closest('[data-dc-bump-add]');
    if (bump && !bump.hasAttribute('disabled')) handleBump(bump);
  });

  const observeDrawer = () => {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer || drawer.dataset.dcUpsellObserved === 'true') return;
    drawer.dataset.dcUpsellObserved = 'true';
    new MutationObserver(publishShown).observe(drawer, {
      attributes: true,
      attributeFilter: ['class'],
      childList: true,
      subtree: true,
    });
    publishShown();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeDrawer, { once: true });
  } else {
    observeDrawer();
  }
})();
